import React from 'react';
import { Box, Typography } from '@mui/material';

const SimpleBallDisplay = ({ lastDrawn, isShuffling, shuffleDisplay, getPrefix }) => {
  const ballColor = getPrefix ? '#808080' : '#1a1a1a';

  return (
    <Box
      sx={{
        width: 260,
        height: 230,
        borderRadius: '50%',
        background: 'linear-gradient(145deg, #404040, #1a1a1a)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',

        border: '2px solid #c0c0c0',
        boxShadow: 'inset 0 0 20px rgba(0,0,0,0.5), 0 5px 15px rgba(0,0,0,0.3)',
      }}
    >
      {isShuffling ? (
        <Typography
          sx={{
            fontSize: '2rem',
            fontWeight: 'bold',
            color: '#c0c0c0',
            animation: 'pulse 2.5s infinite',
            '@keyframes pulse': {
              '0%': { transform: 'scale(1)', opacity: 1 },
              '50%': { transform: 'scale(1.1)', opacity: 0.7 },
              '100%': { transform: 'scale(1)', opacity: 1 },
            },
          }}
        >
          {shuffleDisplay}
        </Typography>
      ) : lastDrawn ? (
        <Box
          key={lastDrawn} // Add key to re-trigger animation
          sx={{
            width: '80%',
            height: '80%',
            borderRadius: '50%',
            backgroundColor: '#1a1a1a',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            color: ballColor,
            animation: 'bounce-in 0.9s cubic-bezier(0.68, -0.55, 0.27, 1.55)',
            '@keyframes bounce-in': {
              '0%': { transform: 'scale(0)', opacity: 0 },
              '50%': { transform: 'scale(1.5)', opacity: 1 },
              '100%': { transform: 'scale(1)', opacity: 1 },
            },
          }}
        >
          <Typography sx={{ fontSize: '2rem', fontWeight: 'bold', color: ballColor }}>
            {getPrefix(lastDrawn)}
          </Typography>
          <Typography sx={{ fontSize: '3rem', fontWeight: 'bold', lineHeight: 1, color: ballColor }}>
            {lastDrawn}
          </Typography>
        </Box>
      ) : (
        <Typography sx={{ fontSize: '2rem', fontWeight: 'bold', color: '#555' }}>
          BINGO
        </Typography>
      )}
    </Box>
  );
};

export default SimpleBallDisplay;
